<template>
	<div>
		<v-container grid-list-xs fluid class="pa-0">
			<v-form ref="unitary_form">
				<v-layout row wrap>
					<v-flex xs12 sm4 md4 lg4 xl4>
						<div class="mb-1 background--text text--lighten-5 subheading">
							# OF *
						</div>
						<v-text-field
							append-icon="search"
							@keydown.enter="getOfDetails(form.parameters.num_of)"
							@click:append="getOfDetails(form.parameters.num_of)"
							clearable
							solo
							name="Numéro OF"
							class="grv-input"
							@click:clear="onOfClear()"
							:rules="[required, numOf]"
							:loading="loading"
							v-model.number="form.parameters.num_of">
						</v-text-field>
					</v-flex>
					<v-flex xs12 sm2 md2 lg2 xl2 class="pl-2">
						<div class="mb-1 background--text text--lighten-5 subheading">
							# FAB *
						</div>
						<v-select
							solo
							dense
							:menu-props="{contentClass: 'grv-menu'}"
							:disabled="of.fvodserv.length === 0"
							class="grv-input"
							:loading="loading"
							:items="of.fvodserv"
							name="Numéro FAB"
							@change="getAssetDetails($event)"
							:rules="[required, numFab]"
							v-model="form.parameters.num_fab">
						</v-select>
					</v-flex>
					<v-flex xs12 sm6 md6 lg6 xl6 class="pl-2">
						<div class="mb-1 background--text text--lighten-5 subheading">
							Machine
						</div>
						<v-select
							solo
							dense
							:menu-props="{contentClass: 'grv-menu'}"
							class="grv-input"
							:items="hosts"
							:rules="[]"
							v-model="host_path">
						</v-select>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12>
						<div class="mb-1 background--text text--lighten-5 subheading">
							Chemin du fichier *
						</div>
						<v-text-field
							solo
							readonly
							class="grv-input file-input"
							:loading="loading"
							name="Chemin du fichier"
							v-model="form.parameters.source_path"
							append-icon="folder"
							:rules="[required]"
							:prefix="getFileBasename(form.parameters.source_path)"
							@click:append="show_explorer = true">
						</v-text-field>
					</v-flex>
				</v-layout>
			</v-form>

			<v-layout row wrap v-if="of.details" class="pt-2">
				<v-flex xs12>
					<table>
						<tbody>
							<tr>
								<th class="px-2 py-1">
									Titre Principal
								</th>
								<td class="px-2 py-1">
									{{ of.titre_princ }}
								</td>
							</tr>
							<tr>
								<th class="px-2 py-1">
									Titre secondaire
								</th>
								<td class="px-2 py-1">
									{{ of.titre_sec }}
								</td>
							</tr>
							<tr>
								<th class="px-2 py-1">
									Observations
								</th>
								<td class="px-2 py-1">
									{{ of.observations }}
								</td>
							</tr>
							<tr>
								<th class="px-2 py-1">
									Référence SUIFA
								</th>
								<td class="px-2 py-1">
									<span
										v-if="of.file_ref === '00_00_0000'"
										class="subheading error--text">
										{{ of.file_ref }}
									</span>
									<span
										v-else
										class="subheading primary--text">
										{{ of.file_ref }}
									</span>
									<v-progress-linear
										class="ma-0"
										:height="2"
										v-if="loading_file_ref"
										:indeterminate="true">
									</v-progress-linear>
								</td>
							</tr>
						</tbody>
					</table>
				</v-flex>
			</v-layout>

			<v-alert outline type="error" class="py-2 my-2" :value="error !== false">
				{{ error }}
			</v-alert>

			<tree-view
				v-if="debug"
				class="ma-2 background darken-1 pa-2"
				:data="form"
				:options="{maxDepth: 0, rootObjectKey: 'form'}" />
			<tree-view
				v-if="debug"
				class="ma-2 background darken-1 pa-2"
				:data="of"
				:options="{maxDepth: 0, rootObjectKey: 'of'}" />
		</v-container>

		<Explorer
			v-if="show_explorer"
			:shortcuts="hosts"
			:assetType="asset_type"
			:multiselect="false"
			:default_folder="host_path"
			@close="show_explorer = false"
			@selectedAssets="onSelectedAsset($event.path)">
			<h3 slot="header">Asset Select for Maestro ingester</h3>
		</Explorer>

	</div>
</template>

<script>
import Explorer from '@/components/modal_explorer.vue'
import Path from 'path'

import config from '../../../../../config/runtime_config.js'

export default {
	props: [ 'debug', 'form' ],
	components: {
		Explorer
	},
	data () {
		return {
			loading: false,
			loading_file_ref: false,
			error: false,
			client_ip: null,
			host_path: null,
			show_explorer: false,
			asset_type: 'file',
			of: {
				details: null,
				observations: null,
				titre_princ: null,
				titre_sec: null,
				file_ref: null,
				fvodserv: []
			},
			hosts: []
		}
	},
	methods: {
		required (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		numOf (value) {
			return /^[0-9]{7}$/.test(value) || 'ex: 1234567'
		},
		numFab (value) {
			return /^[0-9]+$/.test(value) || 'ex: 1'
		},
		getFileBasename (filepath) {
			if (!filepath) return ''
			try {
				return Path.basename(filepath) || ''
			} catch (error) {
				return ''
			}
		},
		getOfDetails (num_of) {
			this.error = false
			this.form.parameters.num_fab = null
			this.form.parameters.source_path = null
			this.of.details = null
			this.of.file_ref = null
			this.of.observations = null
			this.of.titre_princ = null
			this.of.titre_sec = null
			this.of.fvodserv = []
			if (this.numOf(num_of) !== true) {
				this.error = 'Mauvais numéro d\'of ex: 1234567'
				return
			}
			this.loading = true
			this.$ApiNexus.suifa_of_info(num_of)
				.then(result => {
					this.loading = false
					this.of.details = result.data
					let status = this.$commons.deepGet(result, 'data.etat_of.lib_etat_of', null)
					if (status !== 'Lancé') {
						this.error = `L'of n'est pas dans un status lancé : (${status})`
					}
					this.of.observations = this.$commons.deepGet(result, 'data.observations', null)
					this.of.titre_princ = this.$commons.deepGet(result, 'data.titre.titre_princ', null)
					this.of.titre_sec = this.$commons.deepGet(result, 'data.titre.titre_sec', null)
					let fabs = this.$commons.deepGet(result, 'data.fabrications', null)
					fabs.map(fab => {
						let fabCodePresta = this.$commons.deepGet(fab, 'prestation_commune.code_prestation', null)
						let fabStatus = this.$commons.deepGet(fab, 'etat_fab.lib_etat_fab', null)
						if (fabCodePresta === 'FVODSERV' && fabStatus === 'En fabrication') {
							let fabNum = fab.num_fab
							this.of.fvodserv.push(fabNum)
						}
					})
					if (this.of.fvodserv.length > 0) {
						this.of.fvodserv.sort((a, b) => a - b)
						this.form.parameters.num_fab = this.of.fvodserv[0]
						this.getAssetDetails(this.of.fvodserv[0])
					}
				})
				.catch(err => {
					console.log('getOfDetails', num_of, err)
					let errorMessage = `Erreur : Impossible de trouver l'OF ${num_of} `
					errorMessage += ` (${err.message})`
					this.error = errorMessage
					this.loading = false
				})
		},
		getAssetDetails (numFab) {
			this.error = false
			this.of.file_ref = null
			let mat_id = false
			let fabs = this.$commons.deepGet(this.of, 'details.fabrications', false)
			if (!fabs) return
			let fabId = null
			fabs.map(fab => {
				if (fab.num_fab === numFab) {
					fabId = fab.fab_id
				}
			})
			if (fabId === null) return
			let elements = this.$commons.deepGet(this.of, 'details.elements', false)
			if (!elements) return
			elements.map(el => {
				if (el.fab_id === fabId && el.lib_nature_elt === 'Source') {
					mat_id = el.mat_id
				}
			})
			if (!mat_id) return
			this.loading_file_ref = true
			this.$ApiNexus.suifa_asset_info(`suifa-${mat_id}`)
				.then(result => {
					this.loading_file_ref = false
					let refSuifa = this.$commons.deepGet(
						result,
						'data.ref_materiel_proxy',
						null
					)
					if (refSuifa === '00_00_0000') {
						let errorMessage = `Erreur : La référence suifa source `
						errorMessage += `n'a pas encore été créée`
						this.error = errorMessage
					}
					if (!refSuifa) {
						let errorMessage = `Erreur : Impossible de réccuperer `
						errorMessage += `la référence suifa source`
						this.error = errorMessage
					}
					this.of.file_ref = refSuifa
				})
				.catch(err => {
					this.loading_file_ref = false
					let errorMessage = `Erreur : Impossible de réccuperer `
					errorMessage += `la référence suifa source, pas encore indexée`
					this.error = errorMessage
					console.log(err)
				})
		},
		getClientIp () {
			this.$ApiNexus.client_ip()
				.then(result => {
					if (result.data) {
						this.client_ip = result.data
						config._$2kka2u.map(host => {
							if (host.ip === result.data) {
								this.host_path = host.value
							}
						})
					}
					if (!this.host_path) this.host_path = '//1305j552/travaux'
				})
				.catch(error => {
					console.log(error)
				})
		},
		onSelectedAsset (assetPath) {
			this.form.parameters.source_path = assetPath
		},
		onOfClear () {
			this.error = false
			this.form.parameters.num_fab = null
			this.form.parameters.source_path = null
			this.of.details = null
			this.of.file_ref = null
			this.of.observations = null
			this.of.titre_princ = null
			this.of.titre_sec = null
			this.of.fvodserv = []
		},
		validate () {
			let isValid = this.$refs.unitary_form.validate()
			this.form.isValid = isValid
			return isValid
		},
		resetValidation () {
			return this.$refs.unitary_form.resetValidation()
		}
	},
	mounted () {
		this.hosts = this.$Pdms.filter(item => {
			if (item.category === 'SuiFile') return true
			if (item.value === '//1305j552/travaux') return true
			return false
		})
		this.getClientIp()
	}
}
</script>

<style lang="stylus" scoped>
.file-input
	>>>.v-text-field__slot
		.v-text-field__prefix
			font-size: 16px
			font-weight: 600
			margin-top: 5px
			margin-left: 5px
		input
			font-size: 12px
			padding-bottom: 4px
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form_suifile_fvodserv.vue